<template>
  <div
    v-click-outside="hideDropdown"
    class="dg-multi-button"
  >
    <div
      class="mobile-button"
      @click="toggleDropdown"
    >
      <i class="fa fas fa-user-circle-plus" />
    </div>
    <button
      class="desktop-button"
      @click="toggleDropdown"
    >
      <span>{{ label }}</span>
      <div
        :class="{
          arrow: !showDropdown,
          clicked: showDropdown,
        }"
      >
        <i class="fas fa-chevron-down" />
      </div>
    </button>
    <div
      v-if="showDropdown"
      class="dropdown-content"
      @click="hideDropdown"
    >
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        showDropdown: false,
      }
    },
    methods: {
      toggleDropdown() {
        this.showDropdown = !this.showDropdown;
      },
      hideDropdown() {
        this.showDropdown = false;
      },
    },
  }
</script>
